import { render, staticRenderFns } from "./EquipmentsCategorical.vue?vue&type=template&id=280a83cc&scoped=true&"
import script from "./EquipmentsCategorical.vue?vue&type=script&lang=js&"
export * from "./EquipmentsCategorical.vue?vue&type=script&lang=js&"
import style0 from "./EquipmentsCategorical.vue?vue&type=style&index=0&id=280a83cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280a83cc",
  null
  
)

export default component.exports